import StatusChip from '../../../components/StatusChip';
import { OVERALL_BUSINESS_PROFILE_STATUS_COLORS } from '../../../constants/businessProfileStatusConstants.jsx';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

const BusinessProfileTableStatusChip = ({ status, size = 'small', variant = 'filled', className, sx }) => {
  const { businessProfiles } = useTranslatedMessages();
  const label = businessProfiles?.status_labels?.[status];
  const color = OVERALL_BUSINESS_PROFILE_STATUS_COLORS[status];

  if (!label || !color) {
    console.warn(`Unknown status: ${status}`);
    return null;
  }

  return <StatusChip color={color} label={label} size={size} variant={variant} className={className} sx={sx} />;
};

export default BusinessProfileTableStatusChip;
